/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface OriginalProjectDescriptionField
 */
export interface OriginalProjectDescriptionField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof OriginalProjectDescriptionField
     */
    value: string;
}

/**
 * Check if a given object implements the OriginalProjectDescriptionField interface.
 */
export function instanceOfOriginalProjectDescriptionField(value: object): value is OriginalProjectDescriptionField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function OriginalProjectDescriptionFieldFromJSON(json: any): OriginalProjectDescriptionField {
    return OriginalProjectDescriptionFieldFromJSONTyped(json, false);
}

export function OriginalProjectDescriptionFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): OriginalProjectDescriptionField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function OriginalProjectDescriptionFieldToJSON(value?: OriginalProjectDescriptionField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

